import { GTMNoScript, GTMScript } from "../../helpers";
import { BaseGTMRunner } from "../BaseGTM/BaseGTMRunner";
let instance = null;
const FooterEvents = {
    "store locator": "store_locator_click",
};
export class GoogleTagManagerRunner extends BaseGTMRunner {
    constructor() {
        var _a;
        super();
        /**
         * @type {number}
         */
        const currentPath = window.location.pathname.replace(".html", "");
        const cartPath = (_a = this.config.CART_CHECKOUT_PAGE_URL) === null || _a === void 0 ? void 0 : _a.replace(".html", "");
        this.isCartPage = currentPath === cartPath;
        this.isLoyaltyPage = !!document.querySelector("[data-des-app=loyalty]");
        this.gtmContainer = document.getElementById("gtmContainer");
        document.addEventListener("DOMContentLoaded", () => {
            this.onLoadTracking = undefined;
            if (this.gtmContainer) {
                sessionStorage.removeItem("gtmInstance");
                this.onLoadTracking = this.gtmContainer.dataset.onLoadTracking;
                const code = this.gtmContainer.dataset.gtmCode;
                if (code) {
                    this.prepareScripts(code);
                    this.prepareEventsTracking();
                }
            }
        });
    }
    prepareEventsTracking() {
        this.currentName = this.getCurrentNameForGtm();
        if (this.currentName) {
            this.instance = null;
            this.getCurrentDataObject();
            this.trackClick();
            this.trackFooter();
            this.trackDynamicElements();
            this.trackCustomEvents();
            this.trackMessageBusEvents();
            setTimeout(() => {
                this.trackSingleClick();
            }, 5000);
        }
    }
    prepareScripts(code = "GTM-57WFMN3") {
        var _a, _b;
        (_a = window.document.querySelector("head")) === null || _a === void 0 ? void 0 : _a.append(GTMScript(code));
        (_b = window.document.querySelector("body")) === null || _b === void 0 ? void 0 : _b.prepend(GTMNoScript(code));
    }
    trackClick() {
        const attribute = "data-track-click";
        Array.from(window.document.querySelectorAll(`[${attribute}]`)).forEach((element) => {
            element.addEventListener("click", ($event) => {
                var _a;
                const clickedElement = $event.currentTarget;
                if (!clickedElement) {
                    return;
                }
                const trackingType = clickedElement.getAttribute(attribute);
                const label = clickedElement.querySelector(".aem-button__text");
                if (!trackingType || trackingType.length === 0) {
                    return;
                }
                const ctaName = (trackingType === "cta_click" && ((_a = label === null || label === void 0 ? void 0 : label.textContent) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, " ").trim())) || "cta_click";
                const trackingData = { cta_location: this.currentName, cta_name: ctaName };
                this.trackEvent(trackingType, trackingData);
            });
        });
    }
    trackFooter() {
        const links = Array.from(window.document.querySelectorAll("#footer .footer__listsRow .aem-list__link"));
        const subscribeBlock = document.querySelector(".aem-subscribe-form .aem-subscribe-form__send-btn");
        if (subscribeBlock) {
            subscribeBlock.addEventListener("click", () => {
                this.trackEvent("newsletter_subscription", undefined);
            });
        }
        if (links && links.length > 0) {
            links.forEach((link) => {
                link.addEventListener("click", () => {
                    var _a;
                    const name = (_a = link.querySelector(".aem-list__text")) === null || _a === void 0 ? void 0 : _a.innerText.toLocaleLowerCase();
                    const currentFooterEvent = name && name in FooterEvents ? FooterEvents[name] : null;
                    if (currentFooterEvent) {
                        this.trackEvent(currentFooterEvent, undefined);
                    }
                });
            });
        }
    }
    trackSingleClick() {
        const elements = [
            {
                element: [
                    ...window.document.querySelectorAll("header .navigation__link"),
                    ...window.document.querySelectorAll(".navigation__secondLevelContent .aem-list__item > .aem-list__link"),
                ],
                name: "menu_navigation",
                additionalData: (element) => {
                    var _a;
                    const checkElement = element.tagName.toLocaleLowerCase() !== "a" ? element.querySelector("a") : element;
                    return {
                        menu_link: ((_a = checkElement === null || checkElement === void 0 ? void 0 : checkElement.textContent) === null || _a === void 0 ? void 0 : _a.replace(/[\n\r]+|[\s]{2,}/g, " ").trim()) || "",
                    };
                },
            },
            {
                element: window.document.querySelectorAll(".navigation__simpleTeaserLink"),
                name: "list_click",
                additionalData: () => undefined,
            },
            {
                element: window.document.querySelectorAll(".ageconfirmation__actionWrapper .aem-button__container"),
                name: "age_verification",
                additionalData: (element) => {
                    var _a;
                    const elementToCheck = element.tagName.toLocaleLowerCase() === "span" ? (_a = element.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode : element;
                    const checkElement = elementToCheck === null || elementToCheck === void 0 ? void 0 : elementToCheck.classList.contains("ageconfirmation__leaveBtn");
                    return {
                        age_confirmation: checkElement ? "no" : "yes",
                    };
                },
            },
        ];
        elements.forEach(({ element, name, additionalData }) => {
            [...element].forEach((singleElement) => singleElement.addEventListener("click", () => {
                this.trackEvent(name, additionalData(singleElement));
            }));
        });
    }
    trackDynamicElements() {
        const elements = [
            {
                name: "review_interaction",
                additionalData: () => undefined,
                check: (element) => element.classList.contains("trustpilotreviewswidget") ||
                    element.classList.contains("aem-trustpilot-widget__review-content"),
            },
        ];
        document.addEventListener("click", (e) => {
            elements.forEach((element) => {
                if (element.check(e.target)) {
                    this.trackEvent(element.name, element.additionalData());
                }
            });
        });
        // Track FAQ click
        document.addEventListener("click", (event) => {
            if (this.currentName !== "faq-page") {
                return;
            }
            const target = event.target;
            if (target === null || target === void 0 ? void 0 : target.closest(".cmp-accordion__button")) {
                this.trackEvent("faq_click", undefined);
            }
        });
    }
    static getInstance() {
        if (!instance) {
            instance = new GoogleTagManagerRunner();
        }
        return instance;
    }
}
//# sourceMappingURL=GoogleTagManagerRunner.js.map